import Icon from "./Icon.tsx";

export default Icon;
